import { useDispatch, useSelector } from "react-redux";
import { ReduxRootState } from "../../../types/redux-store";
import { bulkModalNotice, bulkModelKey } from "./bulk-create-post.model";

/**
 * Inline alert that surfaces capacity-limit messages from the bulk-create
 * saga (e.g. "you can duplicate up to 20 posts at a time"). CLAUDE.md
 * forbids toasts for plan / feature limitations because they disappear
 * before the user can read them — this banner is sticky inside the modal
 * until the user dismisses or closes the modal.
 */
export const BulkCapacityNotice = () => {
  const dispatch = useDispatch();
  const message = useSelector(
    (state: ReduxRootState) =>
      state[bulkModelKey]?.bulkModalNotice?.capacityMessage ?? null
  );

  if (!message) return null;
  return (
    <div
      // `role="alert"` (assertive) rather than `role="status"` (polite):
      // this banner appears in direct response to a user action that
      // dropped some of their input (e.g. pasting more than the cap).
      // Polite would queue the announcement behind whatever the SR was
      // saying and risk the user missing it.
      role="alert"
      className="bg-primary-50 text-primary-600 text-sm px-3 py-2 mx-4 mt-3 rounded-lg flex items-start gap-2"
      data-testid="bulk-capacity-notice"
    >
      <i className="fa-regular fa-circle-info mt-0.5" aria-hidden="true" />
      <span className="flex-1">{message}</span>
      <button
        type="button"
        className="text-primary-600 hover:text-primary-700 cursor-pointer p-0 m-0"
        onClick={() => dispatch(bulkModalNotice.actions.clear())}
        aria-label="Dismiss notice"
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    </div>
  );
};
